import service from "@/store/services/kit-editor-service";

const state = {
  list: {},
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
};

const actions = {
  destroy({ _ }, id) {
    return service
      .destroy(id)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(false);
      });
  },
  addProductToKit({ _ }, params) {
    return service
      .addProductToKit(params)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  resizeKit({ _ }, params) {
    return service
      .resizeKit(params)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  getAvailableProducts({ _ }, params) {
    return service
      .getAvailableProducts(params)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
};

const getters = {
  list: (state) => state.list,
};

const kit_editor = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default kit_editor;
